module.exports = {"450303001":"叠彩街道","450303002":"北门街道","450303200":"大河乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/450303.json
// module id = 2220
// module chunks = 0